import { Component, inject } from '@angular/core';

import { DialogService } from '@core/user-interface-legacy';

import { EmptyDialogComponent } from './empty-dialog.component';
import { InputAndReturnTypeDialogComponent } from './input-and-return-type-dialog.component';
import { InputOnlyDialogComponent } from './input-only-dialog.component';

@Component({
  selector: 'rt-new-dialog',
  template: `
    <button (click)="openDialog()">Open Dialog</button>
    <button (click)="openEmptyDialog()">Open Empty Dialog</button>
  `,
})
export class NewDialogComponent {
  private dialogService = inject(DialogService);

  public openDialog() {
    const ref = this.dialogService.openDialog(
      InputAndReturnTypeDialogComponent,
      {
        name: 'John Doe',
      },
      {},
    );
    // @ts-expect-error
    ref.close('ee');

    ref.close({ ebe: 'ebe ebe' });
  }
  public openEmptyDialog() {
    this.dialogService.openDialog(EmptyDialogComponent, null, {});
  }

  public inputOnlyDialog() {
    const ref = this.dialogService.openDialog(InputOnlyDialogComponent, { name: 'John Doe' });

    ref.close({ anything: 'anything allowed' });
  }
}
